import { useEffect } from 'react';
import { AccountLayout } from '@/components/AccountLayout';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate, Link } from 'react-router-dom';
import { requireUser } from '@/lib/requireUser';
import { Package } from 'lucide-react';

const MyProducts = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    requireUser({ user, navigate, currentPath: '/account/products' });
  }, [user, navigate]);

  if (!user) return null;

  return (
    <AccountLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">My Products</h1>
          <p className="text-muted-foreground mt-2">Manage your purchased and listed products</p>
        </div>

        {/* Empty State */}
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-16">
            <Package className="h-16 w-16 text-muted-foreground mb-4" />
            <CardTitle className="mb-2">No products yet</CardTitle>
            <CardDescription className="mb-6 text-center">
              You haven't purchased or listed any products yet
            </CardDescription>
            <Link to="/browse">
              <Button>Browse Products</Button>
            </Link>
          </CardContent>
        </Card>

        {/* Purchased Products Section */}
        <Card>
          <CardHeader>
            <CardTitle>Purchase History</CardTitle>
            <CardDescription>Products you've purchased</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">No purchases yet</p>
          </CardContent>
        </Card>
      </div>
    </AccountLayout>
  );
};

export default MyProducts;
